import React, { useState, useEffect } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { alertService } from '_services';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useUIUtils } from 'hooks/useUIUtils';

const AddEdit = ({ history, match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { handleSubmit } = useForm();
    const { id } = match.params;
    const isAddMode = !id;
    let [almacenes, setAlmacenes] = useState([]);
    let [conceptosMov, setConceptosMov] = useState([]);
    let [conceptosInt, setConceptosInt] = useState('');
    let [movimientoDetalles, setMovimientoDetalles] = useState([]);
    let [data, setData] = useState({
        id: 0,
        almacen_Id: 0,
        conceptos_Inv_Id: 0,
        folio: "",
        naturaleza_Concepto: "P",
        almacen_Destino_Id: 0,
        cancelado: "N",
        aplicado: "S",
        descripcion: "",
        sucursal_Id: getDataSession('sucursal'),
    });

    useEffect(() => {
        async function getMovimiento() {
            const mov = await fetchConToken(`existencias/MovimientoInventario?id=${id}&sucursal_Id=${getDataSession('sucursal')}`);
            setData(mov);
            setMovimientoDetalles(mov.movimientos_Inventario_Dets);
        }
        function GetConceptoMovimiento() {
            if (getDataSession('sucursal') === '0') {
                Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
                return;
            }

            fetchConToken(`ConceptosMovInv/List?tipo=S`).then(response => setConceptosMov(response));
        };
        function GetAlmacenes() {
            if (getDataSession('sucursal') === '0') {
                Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
                return;
            }

            fetchConToken(`Almacenes/GetList?paginas=0&totalXpagina=50&sucursal_Id=${getDataSession('sucursal')}`).then(response => setAlmacenes(response.data));
        };
        changeGlobalTitle(isAddMode ? 'Registrar Movimiento' : 'Editar Movimiento',)
        GetConceptoMovimiento();
        GetAlmacenes();
        if (!isAddMode) getMovimiento();
    }, [id, changeGlobalTitle, isAddMode]);

    const loadArticulos = async (query) => {
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }
        var resp = await fetchConToken(`Articulos/ListArtYVar?busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
        return resp;
    };

    async function getArticulo(art) {
        console.log(art)
        if (!Number.isInteger(art?.id)) return;

        if (art.variante === 'N') {
            if (movimientoDetalles.filter((c) => c.articulo_Id === art.id).length > 0) return;

            const detalleMov = {
                id: 0,
                movimiento_Inventario_Id: 0,
                almacen_Id: 0,
                conceptos_Inv_Id: 0,
                clave_Articulo: art.clave,
                articulo_Id: art.id,
                clave_Variante: null,
                variante_Id: null,
                tipo_Movimiento: "P",
                unidades: 0,
                nombre_Articulo: art.nombre
            };
            setMovimientoDetalles(prev => [...prev, detalleMov]);
            return;
        }

        const articulosVariante = await fetchConToken(`Articulos/VarianteById?variante_id=${art.id}`);
        const articulosAux = await fetchConToken(`Articulos?id=${articulosVariante.articulo_Id}&sucursal_Id=${getDataSession('sucursal')}`);
        if (movimientoDetalles.filter((c) => c.articulo_Id === articulosVariante.articulo_Id && c.variante_Id === articulosVariante.id).length > 0) return;

        const detalleMov = {
            id: 0,
            movimiento_Inventario_Id: 0,
            almacen_Id: 0,
            conceptos_Inv_Id: 0,
            clave_Articulo: articulosAux.clave,
            articulo_Id: articulosVariante.articulo_Id,
            clave_Variante: articulosVariante.clave,
            variante_Id: articulosVariante.id,
            tipo_Movimiento: "P",
            unidades: 0,
            nombre_Articulo: articulosVariante.nombre
        };
        setMovimientoDetalles(prev => [...prev, detalleMov]);
    }

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? (target.checked) : target.value;
        const name = target.name;
        setData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === "conceptos_Inv_Id") {
            let concep = conceptosMov.filter((c) => c.id === value);
            setConceptosInt(concep[0]["id_Interno"]);
        }
    }

    const handleInputChangeUnidades = (event, key, variante_id, campo) => {
        const updatedItems = movimientoDetalles.map((det) => det.articulo_Id === key && det.variante_Id === variante_id ? { ...det, unidades: parseFloat(event.target.value) } : det);
        setMovimientoDetalles(updatedItems);
    };

    async function eliminar(id, variante_Id,) { setMovimientoDetalles(movimientoDetalles.filter((item) => item.articulo_Id !== id || item.variante_Id !== variante_Id)); }

    function Cancelar() {
        Swal.fire({
            text: '¿Desea cancelar la venta?',
            showCancelButton: true,
            confirmButtonText: 'Si,Cancelar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchConToken('VxCompras/Cancelar?documento_id=' + id, data, 'POST')
                    .then((response) => {
                        if (response.hasOwnProperty('status')) {
                            Object.entries(response.errors).forEach(([ , value]) => {
                                Swal.fire('Error', value[0], 'error');
                            });
                            return false;
                        } else if (response.hasOwnProperty('codigo')) {
                            Swal.fire('Error', response.mensajes[0], 'error');
                            return;
                        }

                        Swal.fire('Exito', 'Cancelado Correctamente', 'success');
                    }).catch(alertService.error);
            }
        })
    }

    function onSubmit() {
        if (isAddMode && getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }
        return create(data); //isAddMode ? create(data) : update(id, data);
    }

    function create(data) {
        data.movimientos_Inventario_Dets = movimientoDetalles;
        return fetchConToken('existencias/MovimientoInventario', data, 'POST')
            .then((response) => {
                if (response.hasOwnProperty('status')) {
                    Object.entries(response.errors).forEach(([ , value]) => {
                        Swal.fire('Error', value[0], 'error');
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo')) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return;
                }

                Swal.fire('Exito', 'Movimiento agregado', 'success');
                history.push('.');
            }).catch(alertService.error);
    }

    /*function update(id,data) {
        data.vx_Compra_Detalles = compraDetalles;
        return fetchConToken('existencias/MovimientoInventario', data, 'PUT')
        .then((response) => {
            if (response.hasOwnProperty('status')) {
                Object.entries(response.errors).forEach(([ , value]) => {
                    Swal.fire('Error', value[0], 'error');
                });
                return false;
                } else if (response.hasOwnProperty('codigo')) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return ;
                }
            Swal.fire('Exito', Docto+' agregado', 'success');
            history.push('..');
        }).catch(alertService.error);
    }*/

    return (
        <>
            <div className='container-fluid'>
                <form onSubmit={handleSubmit(onSubmit)} className='facturar'>
                    <div className='row'>
                        <div className='col-md-12 text-right'>
                            {isAddMode ?
                                <button
                                    className='btn btn-outline-success'
                                    type='submit'
                                >
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='20'
                                        height='20'
                                        fill='currentColor'
                                        className='bi bi-check-lg'
                                        viewBox='0 0 16 16'
                                    >
                                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                                    </svg>
                                    &nbsp; Guardar
                                </button> : ''}
                            &nbsp;
                            {!isAddMode ?
                                <><button
                                    className='btn btn-outline-success'
                                    onClick={(e) => Cancelar()}
                                    type='button'
                                >
                                    &nbsp; Cancelar
                                </button> &nbsp;</> : ''}
                            <Link to={isAddMode ? '.' : '..'} className='btn btn-outline-warning'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='15'
                                    height='15'
                                    fill='currentColor'
                                    className='bi bi-reply'
                                    viewBox='0 0 16 16'
                                >
                                    <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
                                </svg>
                                &nbsp; Regresar
                            </Link>
                        </div>
                        <div className=''>
                            <div className='col-md-12'>
                                <h5>Información Movimiento</h5>
                                <div className='col-md-12' style={{ display: 'grid' }}>
                                    <div className='card mb-2 '>
                                        <div className='card-body text-start'>
                                            <div className='row col-md-12'>
                                                <div className='col-md-6'>
                                                    <FormControl fullWidth sx={{ m: 1, minWidth: 100 }} size="small">
                                                        <InputLabel id="almacen-origen-label">{conceptosInt === 'TE' || conceptosInt === 'TS' ? "Almacen Origen" : "Almacen"}:</InputLabel>
                                                        <Select id="almacen_Id" name='almacen_Id' labelId="almacen-origen-label" onChange={handleInputChange} value={data?.almacen_Id} label="Almacen">
                                                            {almacenes?.map((item) => { return (<MenuItem key={item.id} value={item.id}><ListItemText primary={item.nombre} /></MenuItem>); })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                <div className='col-md-6'>
                                                    <FormControl fullWidth sx={{ m: 1, minWidth: 100 }} size="small">
                                                        <InputLabel id="conceptos-inv-label">Concepto:</InputLabel>
                                                        <Select id="conceptos_Inv_Id" name='conceptos_Inv_Id' labelId="conceptos-inv-label" onChange={handleInputChange} value={data?.conceptos_Inv_Id} label="Concepto">
                                                            {conceptosMov?.map((item) => { return (<MenuItem key={item.id} value={item.id}><ListItemText primary={item.nombre} /></MenuItem>); })}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                                {(conceptosInt === 'TE' || conceptosInt === 'TS' || (data.id > 0 && data.almacen_Destino_Id > 0)) ?
                                                    <div className='col-md-6'>
                                                        <FormControl fullWidth sx={{ m: 1, minWidth: 100 }} size="small">
                                                            <InputLabel id="almacen-destino-label">Almacen Destino:</InputLabel>
                                                            <Select id="almacen_Destino_Id" name='almacen_Destino_Id' labelId="almacen-destino-label" onChange={handleInputChange} value={data?.almacen_Destino_Id} label="Almacen Destino">
                                                                {almacenes?.map((item) => { return (<MenuItem key={item.id} value={item.id}><ListItemText primary={item.nombre} /></MenuItem>); })}
                                                            </Select>
                                                        </FormControl>
                                                    </div> : <></>}
                                                <div className='col-md-12'>
                                                    <label htmlFor='cp'>Descripcion</label>
                                                    <textarea className='form-control' name='descripcion' onChange={handleInputChange} value={data?.descripcion} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isAddMode ?
                                    <div className='col-12 col-sm-12 col-md-12 text-left'>
                                        <label htmlFor='id'>Buscar Articulo</label>
                                        <AsyncSelect
                                            className='react-select-placeholder'
                                            isClearable
                                            getOptionLabel={(option) => option.clave + '-' + option.nombre}
                                            value=''
                                            getOptionValue={(option) => option.id}
                                            loadOptions={loadArticulos}
                                            onChange={(selectedItem) => { getArticulo(selectedItem); }}
                                        />
                                    </div> : <></>}
                                <div style={{ overflowX: 'auto' }}>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th style={{ display: "none" }}>ID</th>
                                                <th>Clave</th>
                                                <th>Articulo</th>
                                                <th>Cantidad</th>
                                                <th style={{ display: !isAddMode ? "none" : "contents" }} ></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {movimientoDetalles?.map((item) => {
                                                return (
                                                    <tr key={item.id} >
                                                        <td className='text-center' style={{ display: "none" }}>{item.articulo_Id}</td>
                                                        <td className='text-center'>{item.clave_Variante || item.clave_Articulo}</td>
                                                        <td className='text-center'>{item.nombre_Articulo}</td>
                                                        <td className='text-right'>
                                                            <input
                                                                type='number'
                                                                className='form-control'
                                                                name='item.unidades'
                                                                value={item.unidades}
                                                                style={{ width: "200px" }}
                                                                onChange={(event) => handleInputChangeUnidades(event, item.articulo_Id, item.variante_Id, 'unidades')}
                                                            />
                                                        </td>
                                                        <td style={{ display: !isAddMode ? "none" : "contents" }}>
                                                            <button
                                                                type='button'
                                                                className='btn  mr-1'
                                                                onClick={() => eliminar(item.articulo_Id, item.variante_Id)}
                                                            >
                                                                <svg
                                                                    xmlns='http://www.w3.org/2000/svg'
                                                                    width='25'
                                                                    height='25'
                                                                    fill='currentColor'
                                                                    className='bi bi-x-circle-fill'
                                                                    viewBox='0 0 16 16'
                                                                >
                                                                    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
                                                                </svg>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export { AddEdit };
